import { useQuery } from '@tanstack/react-query';
import type { AuditLogEntry, Paginated } from '@electrodavisan/shared';
import { api } from './api';

export interface AuditFilters {
  page: number;
  pageSize: number;
  action?: string;
  entityType?: string;
  actorSub?: string;
}

export function useAuditLog(filters: AuditFilters, enabled = true) {
  return useQuery<Paginated<AuditLogEntry>>({
    queryKey: ['audit', filters],
    queryFn: () =>
      api.get<Paginated<AuditLogEntry>>('/api/admin/audit', {
        query: {
          page: filters.page,
          pageSize: filters.pageSize,
          action: filters.action,
          entityType: filters.entityType,
          actorSub: filters.actorSub,
        },
      }),
    enabled,
    placeholderData: (previous) => previous,
  });
}
